import { Logger, Presenter, type IPresenterOwner } from 'wdc-cube'
import { EmpresasTableScope, type ColumnVisibility, type EmpresasTableVariante, type SortModel } from './mv_scopes'

const LOG = Logger.get('MV-EmpresasTable')

const COLUMN_VISIBILITY_STORAGE_KEY: Record<EmpresasTableVariante, string> = {
    resumo: 'mvEmpresasResumoVisibleColumns',
    completa: 'mvEmpresasCompletaVisibleColumns'
}

export type EmpresasTableHost = IPresenterOwner & {
    fetchListagem(table: EmpresasTableScope, page: number): Promise<void>
    onEmpresaClicked(table: EmpresasTableScope, id: string): Promise<void>
}

export default class MvEmpresasTablePresenter extends Presenter<EmpresasTableScope, EmpresasTableHost> {
    constructor(owner: EmpresasTableHost, scope: EmpresasTableScope, variante: EmpresasTableVariante) {
        super(owner, scope)
        scope.variante = variante
        scope.columnVisibility = loadColumnVisibility(variante)
        scope.onPageChange = this.action(this.__handlePageChange)
        scope.onSortChange = this.action(this.__handleSortChange)
        scope.onRowClicked = this.action(this.__handleRowClicked)
        scope.onColumnVisibilityChange = this.action(this.__handleColumnVisibilityChange)
    }

    // :: Handlers

    private async __handlePageChange(page: number, pageSize: number) {
        this.scope.pageSize = pageSize
        await this.owner.fetchListagem(this.scope, page)
    }

    private async __handleSortChange(sort: SortModel | undefined) {
        this.scope.sort = sort
        await this.owner.fetchListagem(this.scope, 0)
    }

    private async __handleRowClicked(id: string) {
        await this.owner.onEmpresaClicked(this.scope, id)
    }

    private async __handleColumnVisibilityChange(columns: ColumnVisibility) {
        this.scope.columnVisibility = columns
        try {
            localStorage.setItem(COLUMN_VISIBILITY_STORAGE_KEY[this.scope.variante], JSON.stringify(columns))
        } catch (caught) {
            LOG.warn('Não foi possível salvar as colunas visíveis', caught)
        }
    }
}

function loadColumnVisibility(variante: EmpresasTableVariante): ColumnVisibility {
    try {
        const saved = localStorage.getItem(COLUMN_VISIBILITY_STORAGE_KEY[variante])
        const parsed: unknown = saved ? JSON.parse(saved) : undefined
        return parsed && typeof parsed === 'object' ? (parsed as ColumnVisibility) : {}
    } catch {
        return {}
    }
}
